import { ApiBase } from '@/api/api'
import { makePostRequest } from '@/api/fetchCalls'
import type { MeasureType } from '@/domain/model/measures'

export type AddNewScoreProps = {
  formId: string
  clientId: string
  questionId: string
  data: Partial<MeasureType>
}
export const addNewScore = async ({
  formId,
  clientId,
  questionId,
  data,
}: AddNewScoreProps): Promise<MeasureType> => {
  return makePostRequest(
    ApiBase +
      `/forms/${formId}/measures/customers/${clientId}/questions/${questionId}`,
    {
      body: JSON.stringify(data),
    }
  )
}
